// extracted by mini-css-extract-plugin
export default {"stockimage":"Introduction_stockimage__GKVB6","welcome":"Introduction_welcome__x1Yu4","introduction":"Introduction_introduction__doL37","introImg":"Introduction_introImg__kRCMh"};